import React from 'react';
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, Spinner } from 'reactstrap';

// Confirms an immediate member removal (there is no scheduled removal).
const RemoveMemberModal = ({ isOpen, member, groupName, saving, onClose, onSubmit }) => {
  if (!member) return null;

  const close = saving ? undefined : onClose;

  return (
    <Modal isOpen={isOpen} toggle={close} className="modal-dialog-centered">
      <ModalHeader toggle={close}>
        Remove {member.name}
        {groupName ? ` from ${groupName}` : ''}?
      </ModalHeader>
      <ModalBody>
        Their access ends immediately and this can't be undone. Their account and watch history are kept, and they'll
        get an email saying their membership has ended.
      </ModalBody>
      <ModalFooter>
        <Button type="button" onClick={onClose} disabled={saving}>
          Cancel
        </Button>
        <Button color="danger" type="button" disabled={saving} onClick={onSubmit}>
          {saving && <Spinner size="sm" className="mr-2" />}
          Remove member
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default RemoveMemberModal;
